import dayjs from "dayjs";
import { PICK_DAY_GAP_DAYS } from "constants/PickingConstant";
import { formatDate, parseDate, pickDayForDeliveryDate } from "functions/pickDay";

/** DD-MM-YYYY <-> dayjs, without relying on dayjs' format parsing (not loaded in this app). */
export const toDayjs = (value) => {
  const date = parseDate(value);
  return date ? dayjs(new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate())) : dayjs();
};

/** Today on this computer's calendar, as DD-MM-YYYY. */
export const todayDate = () => {
  const now = new Date();
  return formatDate(new Date(Date.UTC(now.getFullYear(), now.getMonth(), now.getDate())));
};

export const todayPickDay = () => pickDayForDeliveryDate(todayDate(), { gapDays: PICK_DAY_GAP_DAYS });

/** A4 with a margin, for everything the orderpicking pages print. */
export const A4_PAGE_STYLE =
  "@page { size: A4 portrait; margin: 10mm; } html, body { margin: 0; -webkit-print-color-adjust: exact; print-color-adjust: exact; }";
